import { EyeOutlined } from '@ant-design/icons';
import { Popover, Image } from 'antd';
import { OrderProduct } from 'components/LightConversation/components/OrderCard/OrderProduct';
import { getOrderProductPropsFromTradeProduct } from 'components/LightConversation/utils/order';
import { css } from '@emotion/css';

interface RelatedOrderItemsProps {
  platform: General.Platform;
  unit: string;
  items: Conversation.Trade.Product[];
}

const MAX_VISIBLE_COUNT = 5;

export const RelatedOrderItems = (props: RelatedOrderItemsProps) => {
  const { platform, unit, items } = props;

  const overflowCount = Math.max(items.length - MAX_VISIBLE_COUNT, 0);
  const visibleItems = items.slice(0, MAX_VISIBLE_COUNT);
  const content = (
    <div className="flex flex-col gap-2 max-w-[400px] max-h-[200px] overflow-y-auto p-3">
      {items.map((item, index) => (
        <OrderProduct
          simple
          key={`${item.externalItemId}_${item.externalSkuId}_${index}`}
          platform={platform}
          unit={unit}
          {...getOrderProductPropsFromTradeProduct(item)}
        />
      ))}
    </div>
  );

  return (
    <Popover
      content={content}
      overlayClassName={overlayCls}
      getPopupContainer={(triggerRef) => triggerRef.parentElement?.parentElement?.parentElement!}
    >
      <div
        className="mt-2 inline-flex items-center gap-2 flex-grow-0 flex-wrap"
        onClick={(e) => e.stopPropagation()}
      >
        {visibleItems.map((item, index) => {
          const isLast = index === MAX_VISIBLE_COUNT - 1;
          return (
            <div className="relative w-[48px] h-[48px] border border-solid border-[#F0F2F5] rounded-[2px]">
              <Image
                key={`${item.externalItemId}_${item.externalSkuId}_${index}`}
                width={48}
                height={48}
                src={item.itemPic}
                className="border border-solid border-[#ECECEC] rounded-sm"
                preview={
                  isLast
                    ? false
                    : {
                        mask: <EyeOutlined />,
                      }
                }
              />
              {isLast && (
                <div className="absolute top-0 right-0 bottom-0 left-0 bg-[#171616] opacity-40 text-xs text-[#ffffff] flex items-center justify-center">
                  +{overflowCount}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Popover>
  );
};

const overlayCls = css`
  .ant-popover-inner-content {
    padding: 0;
  }

  .ant-popover-arrow {
    display: none;
  }
`;
